var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "even",
    clipRule: "evenodd",
    d: "M8.0013 8C8.73768 8 9.33464 8.59695 9.33464 9.33333V20.2667C9.33464 21.4088 9.33567 22.1852 9.38471 22.7853C9.43247 23.3698 9.51903 23.6688 9.62529 23.8773C9.88095 24.3791 10.2889 24.787 10.7907 25.0427C10.9992 25.1489 11.2981 25.2355 11.8827 25.2833C12.4828 25.3323 13.2592 25.3333 14.4013 25.3333H17.6013C18.7434 25.3333 19.5198 25.3323 20.1199 25.2833C20.7045 25.2355 21.0034 25.1489 21.2119 25.0427C21.7137 24.787 22.1217 24.3791 22.3773 23.8773C22.4836 23.6688 22.5701 23.3698 22.6179 22.7853C22.6669 22.1852 22.668 21.4088 22.668 20.2667V9.33333C22.668 8.59695 23.2649 8 24.0013 8C24.7377 8 25.3346 8.59695 25.3346 9.33333V20.3217C25.3347 21.395 25.3347 22.2808 25.2757 23.0024C25.2145 23.7519 25.0831 24.4408 24.7533 25.0879C24.242 26.0915 23.4261 26.9074 22.4226 27.4187C21.7755 27.7484 21.0865 27.8798 20.3371 27.9411C19.6155 28 18.7296 28 17.6563 28H14.3463C13.273 28 12.3871 28 11.6655 27.9411C10.9161 27.8798 10.2271 27.7484 9.58002 27.4187C8.57649 26.9074 7.76059 26.0915 7.24927 25.0879C6.91955 24.4408 6.78813 23.7519 6.72689 23.0024C6.66794 22.2808 6.66795 21.395 6.66797 20.3217L6.66797 9.33333C6.66797 8.59695 7.26492 8 8.0013 8Z",
    fill: "#0f0b2899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "even",
    clipRule: "evenodd",
    d: "M16 20.0002C15.2636 20.0002 14.6667 20.5971 14.6667 21.3335V25.3335H12V21.3335C12 19.1244 13.7909 17.3335 16 17.3335C18.2091 17.3335 20 19.1244 20 21.3335V25.3335H17.3333V21.3335C17.3333 20.5971 16.7364 20.0002 16 20.0002Z",
    fill: "#0f0b2899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "even",
    clipRule: "evenodd",
    d: "M4.14106 11.2627C4.47037 11.9213 5.27127 12.1883 5.92991 11.8589L16.0003 6.82375L26.0707 11.8589C26.7293 12.1883 27.5302 11.9213 27.8595 11.2627C28.1889 10.604 27.9219 9.80312 27.2632 9.47381L16.5966 4.14047C16.2212 3.95279 15.7794 3.95279 15.404 4.14047L4.73734 9.47381C4.0787 9.80312 3.81174 10.604 4.14106 11.2627Z",
    fill: "#0f0b2899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDHome);
export default __webpack_public_path__ + "static/media/DHome.1b6a43f8844706b1df72d5d21208cf88.svg";
export { ForwardRef as ReactComponent };